import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ScopedCssBaseline, ThemeProvider } from '@mui/material';

import iziclaiMarque from '../assets/iziclai_marque.png';
import themeAssure from './theme';

/** Les mentions obligatoires, atteignables de partout et sans bruit. */
export default function PiedDePage() {
  return (
    <ThemeProvider theme={themeAssure}>
      <ScopedCssBaseline>
        <Box component="footer"
             sx={{ borderTop: '1px solid', borderColor: 'divider',
                   bgcolor: 'background.default', py: 3, mt: 6 }}
             className="sans-impression">
          <Container maxWidth="md">
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}
                   justifyContent="space-between" alignItems={{ sm: 'center' }}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box component="img" src={iziclaiMarque} alt=""
                     sx={{ width: 28, height: 28, flexShrink: 0 }} />
                <Typography variant="caption" color="text.secondary">
                  Iziclai — Expomis SARL-S, Steinfort (Luxembourg). Les
                  montants affichés sont des repères, pas des engagements de
                  votre assureur.
                </Typography>
              </Stack>
              <Stack direction="row" spacing={2}>
                <Typography variant="caption" component={Link} to="/conditions"
                            sx={{ color: 'text.secondary' }}>
                  Conditions d'utilisation
                </Typography>
                <Typography variant="caption" component={Link}
                            to="/confidentialite"
                            sx={{ color: 'text.secondary' }}>
                  Données et cookies
                </Typography>
              </Stack>
            </Stack>
          </Container>
        </Box>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}
